import * as React from 'react';

import { IMediaGalleryVideo } from '../classes/media-gallery';

export interface VideoCarouselItemProps {
    video: IMediaGalleryVideo;
}

const videoCarouselItemView: React.StatelessComponent<VideoCarouselItemProps> = props => {
    return (
        <div className="swiper-slide">
            <div className="item item-media">
                <div className="item-image-wrapper">
                    <div className="item-embed">
                        <iframe src={`https://www.youtube.com/embed/${props.video.youtubeId}?enablejsapi=1`} frameBorder="0" allowFullScreen></iframe>
                    </div>
                </div>

                <div className="item-content">
                    <div className="item-description">
                        <p>{props.video.caption}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default videoCarouselItemView;


// WEBPACK FOOTER //
// ./app/views/video-carousel-item.tsx